var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdinYello(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5609 5.09766C11.6477 5.09766 12.6899 5.52936 13.4584 6.2978C14.2268 7.06625 14.6585 8.10848 14.6585 9.19522V13.9757H11.9268V9.19522C11.9268 8.83297 11.7829 8.48556 11.5267 8.22941C11.2706 7.97327 10.9232 7.82936 10.5609 7.82936C10.1987 7.82936 9.85128 7.97327 9.59514 8.22941C9.33899 8.48556 9.19509 8.83297 9.19509 9.19522V13.9757H6.46338V9.19522C6.46338 8.10848 6.89509 7.06625 7.66353 6.2978C8.43197 5.52936 9.4742 5.09766 10.5609 5.09766Z",
    stroke: "#F8B326",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73171 5.78052H1V13.9756H3.73171V5.78052Z",
    stroke: "#F8B326",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36585 3.73171C3.12019 3.73171 3.73171 3.12019 3.73171 2.36585C3.73171 1.61151 3.12019 1 2.36585 1C1.61151 1 1 1.61151 1 2.36585C1 3.12019 1.61151 3.73171 2.36585 3.73171Z",
    stroke: "#F8B326",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinYello);
export default __webpack_public_path__ + "static/media/linkdinYello.add8cafc1bba950e05cf92a4f2ab6457.svg";
export { ForwardRef as ReactComponent };